import React from 'react';
import { useTranslation } from 'react-i18next';
import './ConfirmationModal.css';

const ConfirmationModal = ({ id, handleConfirm, handleClose, titleText, bodyText }) => {
    const { t } = useTranslation();

    return (
        <div className='cfm-overlay'>
            <div id={id} className='cfm-modal'>

                {/* ── Header ── */}
                <div className='cfm-header'>
                    <h2 className='cfm-title'>{titleText}</h2>
                    <button className='cfm-close-btn' onClick={handleClose} aria-label='Close'>
                        <span className='material-symbols-outlined'>close</span>
                    </button>
                </div>

                {/* ── Body ── */}
                <div className='cfm-body'>
                    <p>{bodyText}</p>
                </div>

                {/* ── Footer ── */}
                <div className='cfm-footer'>
                    <button className='cfm-btn cfm-btn-cancel' onClick={handleClose}>{t('Cancel')}</button>
                    <button className='cfm-btn cfm-btn-confirm' onClick={handleConfirm}>{t('Confirm')}</button>
                </div>

            </div>
        </div>
    );
};

export default ConfirmationModal;
